export default __webpack_public_path__ + "static/media/composition-img.94b5cfbf.svg";